import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const FAVORITE_QUERY = gql`
  query favorite($documentVersion: DocumentVersionInput!
    $language: String!) {
    favorite(documentVersion: $documentVersion,
      language: $language) {
      documentId
      lineId
      title
      variables {
        id
        value
        text
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FavoriteQuery extends Query<RootQuery> {
  document = FAVORITE_QUERY;
}
